import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

export enum StepState {
  Error,
  Completed,
  Warning,
}

export interface NavStepHeaderState {
  completed: boolean;
  hasError: boolean;
  hasWarning: boolean;
}

@Injectable()
export class NavStepHeaderStore extends ComponentStore<NavStepHeaderState> {
  stepState$ = this.select(state => {
    if (state.hasWarning) {
      return StepState.Warning;
    }
    if (state.hasError) {
      return StepState.Error;
    }
    if (state.completed) {
      return StepState.Completed;
    }
  });

  constructor() {
    super({
      completed: false,
      hasError: false,
      hasWarning: false,
    });
  }

  public readonly setCompleted = this.updater((state, completed: boolean) => {
    return { ...state, completed };
  });

  public readonly setWarning = this.updater((state, hasWarning: boolean) => {
    return { ...state, hasWarning, hasError: false };
  });

  public readonly setHasError = this.updater((state, hasError: boolean) => {
    return { ...state, hasError, hasWarning: false };
  });
}
